
import React from "react";
import { Button } from "@/components/ui/button";

interface PlatformSelectorProps {
  platform: 'youtube' | 'vimeo';
  setPlatform: (platform: 'youtube' | 'vimeo') => void;
}

const PlatformSelector = ({ platform, setPlatform }: PlatformSelectorProps) => {
  return (
    <div className="flex gap-2">
      <Button
        type="button"
        variant={platform === 'youtube' ? "default" : "outline"}
        onClick={() => setPlatform('youtube')}
        className="flex-1"
      >
        YouTube
      </Button>
      <Button
        type="button"
        variant={platform === 'vimeo' ? "default" : "outline"}
        onClick={() => setPlatform('vimeo')}
        className="flex-1"
      >
        Vimeo
      </Button>
    </div>
  );
};

export default PlatformSelector;
